import { LowLatencyHostInfo } from '@/components/LowLatencyHosts/types'

import { ActionDeleteItem } from '../ActionDeleteItem/ActionDeleteItem'

interface ActionDeleteLowLatencyHostItemProps {
  onDelete: (id: number) => Promise<void> | void
}

export const ActionDeleteLowLatencyHostItem = ({
  onDelete
}: ActionDeleteLowLatencyHostItemProps) => (
  <ActionDeleteItem
    displaySeparately
    isDeletable={(data: LowLatencyHostInfo) => !data.inUse}
    onDelete={(data) => onDelete(data.id)}
    successMessage={(data) => `${data.displayName} deleted successfully`}
    errorMessage={(data) => `Failed to delete ${data.displayName}`}
    confirmationMessage={(data) => `Are you sure you want to delete host ${data.displayName}?`}
  />
)
